import * as React from 'react';
import Button from 'antd/lib/button';
import Form, { FormComponentProps } from 'antd/lib/form';
import Row from 'antd/lib/row';
import TextField from '../../Components/TextField';
import './BoxForgetPass.scss';
import { Divider } from '@material-ui/core';

export interface IBoxForgetPassProps extends FormComponentProps {
	onRecovery: (email: string) => void;
	onReturn: () => void;
	isChecking: boolean;
}
const rulesEmail = [
	{
		required: true,
		message: 'El Correo Empresarial es requerido'
	},
	{
		type: 'email',
		message: 'Debe escribir un correo valido'
	}
];
const BoxForgetPass = (props: IBoxForgetPassProps) => {
  const { getFieldDecorator } = props.form;
  const onSubmit = (evt: React.FormEvent) => {
    evt.preventDefault();
    props.form.validateFields((errs, values) => {
      props.onRecovery(values.email);
    });
  };
  return (
    <div className='box-forget-form'>
      <Form onSubmit={onSubmit}>
        <h2>Bienvenido</h2>
        <p>Recuperar el acceso perdido</p>
        <Row className='box-forget-text-field'>
          {getFieldDecorator('email', {
						rules: rulesEmail
					})(
            <TextField
              style={{ width: '100%' }}
              label='Correo corporativo'
              variant='outlined'
              margin='normal'
            />
          )}
        </Row>
        <Button disabled={props.isChecking} htmlType="submit" type='primary' block>
          Recuperar
        </Button>
				<Divider />
				<Button disabled={props.isChecking}  className="btn-forget-return" type='link' onClick={props.onReturn} block>
          Volver
        </Button>
      </Form>
    </div>
  );
};

export default Form.create<IBoxForgetPassProps>()(BoxForgetPass);
